var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Box, Card, Stack, Typography, useMediaQuery } from "@mui/material";
import { FormItemTypes } from "../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { DynamicFormBuilderContainer } from "../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { CloseWithoutBorder } from "../../../../../assets/images";
import { DynamicCatalogBuilder } from "../../../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder";
var ParametersCheckedModel = function (_ref) {
    var _ref3;
    var onClose = _ref.onClose, data = _ref.data, title = _ref.title;
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var formData = [{
            type: FormItemTypes.ContainerItem,
            columnSize: 12,
            name: 'header',
            p: 2,
            spacing: 0,
            elements: [{
                    type: FormItemTypes.Typography,
                    name: 'headername',
                    children: title,
                    fontSize: 'xl',
                    fontWeight: '600',
                    columnSize: true
                }, {
                    type: FormItemTypes.IconButton,
                    label: '',
                    name: '',
                    value: null,
                    columnSize: 1,
                    children: /*#__PURE__*/ React.createElement("img", {
                        src: CloseWithoutBorder
                    }),
                    onClick: function () {
                        onClose();
                    }
                }]
        }];
    var Columns = [{
            field: "FieldFailureReportDocumentName",
            headerName: "AFR number",
            minWidth: 40
        }, {
            field: "ParameterBeforeRepair",
            headerName: "Parameter Before Repair",
            flex: 1
        }, {
            field: "ParameterAfterRepair",
            headerName: "Parameter after repair",
            flex: 1
        }, {
            field: "ObservationBeforeRapair",
            headerName: "Observation before repair",
            flex: 1
        }, {
            field: "ObservationAfterRapair",
            headerName: "Observation after repair",
            flex: 1
        }];
    var MobileFormData = [{
            type: FormItemTypes.List,
            name: '',
            columnSize: 12,
            getRowHeight: function () { return 'auto'; },
            columns: [{
                    field: "FieldFailureReportDocumentName",
                    headerName: "AFR number",
                    flex: 1,
                    renderCell: function (_ref2) {
                        var _row$ParameterBeforeR, _row$ParameterAfterRe, _row$ObservationBefor, _row$ObservationAfter;
                        var row = _ref2.row;
                        return /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(Typography, {
                            p: 1,
                            fontWeight: 'bold',
                            fontSize: 'md'
                        }, row === null || row === void 0 ? void 0 : row.FieldFailureReportDocumentName), /*#__PURE__*/ React.createElement(Card, {
                            sx: {
                                border: 'none',
                                width: '100%',
                                boxShadow: 'none',
                                bgcolor: 'secondary.50',
                                p: 1,
                                mb: 2
                            }
                        }, /*#__PURE__*/ React.createElement(Typography, {
                            color: 'text.secondary'
                        }, "Parameter before repair"), /*#__PURE__*/ React.createElement(Typography, null, (_row$ParameterBeforeR = row === null || row === void 0 ? void 0 : row.ParameterBeforeRepair) !== null && _row$ParameterBeforeR !== void 0 ? _row$ParameterBeforeR : '-'), /*#__PURE__*/ React.createElement(Typography, {
                            color: 'text.secondary'
                        }, "Parameter after repair"), /*#__PURE__*/ React.createElement(Typography, null, (_row$ParameterAfterRe = row === null || row === void 0 ? void 0 : row.ParameterAfterRepair) !== null && _row$ParameterAfterRe !== void 0 ? _row$ParameterAfterRe : '-'), /*#__PURE__*/ React.createElement(Typography, {
                            color: 'text.secondary'
                        }, "Observation before repair"), /*#__PURE__*/ React.createElement(Typography, null, (_row$ObservationBefor = row === null || row === void 0 ? void 0 : row.ObservationBeforeRapair) !== null && _row$ObservationBefor !== void 0 ? _row$ObservationBefor : '-'), /*#__PURE__*/ React.createElement(Typography, {
                            color: 'text.secondary'
                        }, "Observation after repair"), /*#__PURE__*/ React.createElement(Typography, null, (_row$ObservationAfter = row === null || row === void 0 ? void 0 : row.ObservationAfterRapair) !== null && _row$ObservationAfter !== void 0 ? _row$ObservationAfter : '-')));
                    }
                }],
            value: data,
            disableCheckboxSelection: true
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        mode: "edit",
        getFormAPI: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ({
                        data: data,
                        success: true
                    })];
            });
        }); },
        gridProps: {
            spacing: 0
        }
    }), /*#__PURE__*/ React.createElement(Stack, {
        margin: 2
    }, lgMode ? /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        columns: Columns,
        rows: (_ref3 = data) !== null && _ref3 !== void 0 ? _ref3 : [],
        dataGridProps: {
            hideFooter: true
        }
    }) : /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: MobileFormData,
        mode: "edit",
        getFormAPI: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ({
                        data: data,
                        success: true
                    })];
            });
        }); },
        gridProps: {
            spacing: 0
        }
    })));
};
export default ParametersCheckedModel;
